import _ from 'lodash'
import React, { Component } from 'react';
import ReactDOM, { findDOMNode } from 'react-dom';
import { connect } from 'react-redux'
import { Field, FieldArray, change } from 'redux-form'
import text from './types/Text.js'
import color from './types/Color.js'
import textarea from './types/TextArea.js'
import number from './types/Number.js'
import checkbox from './types/Checkbox.js'
import icon from './types/Icon.js'
import select from './types/Select.js'
import editor from './types/Editor.js'
import media from './types/Media.js'
import separator from './types/Separator.js'
import module from './types/Module.js'
import boxElement from './types/BoxElement.js'
import builder from './types/Builder.js'
import repeatField from './RepeatField.js'
import BoxShadow from './types/BoxShadow'
import Slider from './types/Slider'
import Fontstyle from './types/Fontstyle'
import Fonts from './types/Fonts'

import ResponsiveManager from '../ResponsiveManager';

class FieldsRender extends Component {

  constructor(props) {
    super(props);

    this.updateResponsiveData = this.updateResponsiveData.bind(this);

    this.state = {
      responsiveDevice: ResponsiveManager.device
    };
  }

  componentDidMount(){
    ResponsiveManager.on('change', this.updateResponsiveData);
  }

  componentWillUnmount(){
    ResponsiveManager.removeListener('change', this.updateResponsiveData);
  }

  updateResponsiveData(){
    this.setState({
      responsiveDevice: ResponsiveManager.device
    });
  }

  _renderFiled( flOps, key ){

    switch ( flOps.type ) {
      case 'text':
      case 'gmap':
          return(
            <Field params={flOps} component={text} name={key} />
          )
        break;

      case 'select':
      case 'animation':
      case 'category':
      case 'accesslevel':
          return(
            <Field params={flOps} component={select} name={key} />
          )
        break;

      case 'color':
          return(
            <Field params={flOps} component={color} name={key} />
          )
        break;

      case 'textarea':
          return(
            <Field params={flOps} component={textarea} name={key} />
          )
        break;

      case 'separator':
          return(
            <Field params={flOps} component={separator} name={key} />
          )
        break;

      case 'number':
          return(
            <Field params={flOps} component={number} name={key} responsiveDevice={this.state.responsiveDevice} />
          )
        break;

      case 'module':
          return(
            <Field params={flOps} component={module} name={key} />
          )
        break;

      case 'checkbox':
          return(
            <Field params={flOps} component={checkbox} name={key} />
          )
        break;

      case 'icon':
          return(
            <Field params={flOps} component={icon} name={key} />
          )
        break;

      case 'editor':
          return(
            <Field params={flOps} component={editor} name={key} />
          )
        break;

      case 'media':
          return(
            <Field params={flOps} component={media} name={key} />
          )
        break;

      case 'padding':
      case 'margin':
          return(
            <Field params={flOps} component={boxElement} name={key} responsiveDevice={this.state.responsiveDevice} />
          )
        break;

      case 'builder':
          return(
            <Field params={flOps} component={builder} name={key} />
          )
        break;

      case 'boxshadow':
          return(
            <Field params={flOps} component={BoxShadow} name={key} />
          )
        break;

      case 'slider':
          return(
            <Field params={flOps} component={Slider} name={key} responsiveDevice={this.state.responsiveDevice} />
          )
        break;

      case 'fontstyle':
          return(
            <Field params={flOps} component={Fontstyle} name={key} />
          )
        break;

      case 'fonts':
          return(
            <Field params={flOps} component={Fonts} name={key} />
          )
        break;

      default:
        return;
    }
  }

  renderFields(){
      const { fieldsAttr, values } = this.props;


      return(
        <div>
          {
            _.map( fieldsAttr,( flOptions, key ) => {

              if (typeof this.props.parentKey != 'undefined') {
                key = `${this.props.element}.${key}`;
              }

              if ( typeof flOptions.depends != 'undefined' ) {

                if ( typeof flOptions.depends.length == 'undefined' ) {

                  var dependKey = Object.keys( flOptions.depends )[0];
                  if ( values[dependKey] != flOptions.depends[dependKey] ) {
                    return;
                  }

                } else if ( flOptions.depends.length > 0 ) {

                  var conditionDepends = true;
                  var condition_depends = true;

                  for (var i = 0; i < flOptions.depends.length; i++) {

                    var dependKey   = flOptions.depends[i][0];
                    var operator    = flOptions.depends[i][1];
                    var dependVal   = flOptions.depends[i][2];

                    if( operator == '=' ) {

                      if(dependVal == ''){
                        if ( typeof values[dependKey] === 'undefined' ) {
                          condition_depends = false;
                        } else if(dependVal == values[dependKey]) {
                          condition_depends = true;
                        } else {
                          condition_depends = false;
                        }
                      } else {
                        if ( dependVal == values[dependKey] ) {
                          condition_depends = true;
                        } else {
                          condition_depends = false;
                        }
                      }

                    } else if( operator == '!=' ) {


                      if(dependVal == ''){
                        if(typeof values[dependKey] === 'undefined'){

                          condition_depends = false;
                        } else if(dependVal != values[dependKey]) {
                          condition_depends = true;
                        } else {
                          condition_depends = false;
                        }
                      } else {
                        if ( dependVal != values[dependKey] ) {
                          condition_depends = true;
                        } else {
                          condition_depends = false;
                        }
                      }
                    }

                    if( conditionDepends == true && condition_depends == true){
                      conditionDepends = true;
                    } else{
                      conditionDepends = false;
                    }
                  }

                  if ( !conditionDepends ) {
                    return;
                  }
                }
              }

              return(
                <div key={ key } className="form-fields">
                  <div>
                    { this._renderFiled( flOptions, key ) }
                    { ( ( typeof flOptions.type === "undefined" || flOptions.type == 'repeatable' ) && typeof flOptions.attr !== "undefined" ) &&
                      <FieldArray
                        flOptions = { flOptions }
                        name = { key }
                        parentKey = { key }
                        component = { repeatField }/>
                    }
                  </div>
                </div>
                )
            })
          }
        </div>
      )
  }

  render(){
    return(
      <div className="sppb-tab-fields">
        { this.renderFields() }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    state
  };
}


export default connect(
  mapStateToProps
)(FieldsRender);



// WEBPACK FOOTER //
// ./src/helpers/form/FieldsRender.js